import FileViewer from './FileViewer'
import { useAuthContext } from '../../../../hooks/useAuthContext'

/**
 * StandaloneFilePreview
 * Used from data preview panels (NormalFieldPreview, TableFieldView, etc.)
 * Delegates to FileViewer which handles all file types.
 */
const StandaloneFilePreview = ({ open, onClose, fileKey }) => {
  const { user } = useAuthContext()
  return <FileViewer open={open} onClose={onClose} fileKey={fileKey} user={user} />
}

export default StandaloneFilePreview
